import { Seo } from "../components/Seo";
import { Hero } from "../components/home/Hero";
import { Pillars } from "../components/home/Pillars";
import { Gathering } from "../components/home/Gathering";
import { Mission } from "../components/home/Mission";
import { Explore } from "../components/home/Explore";
import { LatestSermon } from "../components/home/LatestSermon";
import { Marquee } from "../components/Brand";
import { VisitBand } from "../components/VisitBand";
import { SITE } from "../content/site";

export default function Home() {
  return (
    <>
      <Seo
        title="GNP Church | God's Name Proclaimed | Youngstown, Ohio"
        description="Discover GNP Church, God's Name Proclaimed, in Youngstown, Ohio. Explore our mission, biblical teaching, worship, discipleship, and gatherings."
        path="/"
      />
      <Hero />
      <Marquee items={SITE.motto} />
      <Pillars />
      <Gathering />
      <LatestSermon />
      <Mission />
      <Explore />
      <VisitBand testId="home-visit-band" />
    </>
  );
}
